const ProductEvents = {
  PRICE_CHANGE_SUBMITTED: 'price_change_submitted',
  REPORT_EXPORTED: 'report_exported',
  DASHBOARD_VIEWED: 'dashboard_viewed',
  FILTER_APPLIED: 'filter_applied',
  ALERT_OPENED: 'alert_opened',
}

const ReportNames = {
  PERFORMANCE: 'performance',
  POLE_PRICE_AUDIT: 'pole_price_audit',
}

const FilterTypes = {
  STATION: 'station',
  STATION_GROUP: 'station_group',
  COMPETITOR_STATION: 'competitor_station',
  GRADE: 'grade',
  GROUP: 'group',
  PERIOD: 'period',
  REGION: 'region',
  TIME_RESOLUTION: 'time_resolution',
  SPLIT_BY: 'split_by',
  STATUS: 'status',
}

export { ProductEvents, ReportNames, FilterTypes }
